module.exports = __webpack_public_path__ + "img/7.6baac4e6.jpg";